/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import {
  IDocumentManagementData,
  IDocumentManagementState,
} from "types/models/document-management";
import { RootState } from "types/reducer";

const initialState: IDocumentManagementState = {
  data: [],
  file_data: {
    document_extract: {
      original_text: '',
      document_text: '',
      match_lv_1: '',
      match_lv_2: '',
      normal_txt: '',
      regex_pattern_lv_1: '',
      regex_pattern_lv_2: '',
      chunk_size: '',
      chunk_overlap: '',
      radio_select: 'chunk_length',
      fileName: '',
    },
    split_document: [],
    doc_properties: {},
    file_name: '',
    file_path: '',
    duplicate_file: false,
    save_chunk: {
      uid: '',
      status: '',
      chunk_total: 0,
    },
    status_extract_file: {
      isFetched: false,
      isFetching: false,
    },
    status_preview_file: {
      isFetched: false,
      isFetching: false,
    },
    status_split_file: {
      isFetched: false,
      isFetching: false,
    },
    status_view_chunks: {
      isFetched: false,
      isFetching: false,
    },
  },
  regex_pattern: {
    level_1: [],
    level_2: []
  }
};

const defaultFileData = {
  document_extract: {
    original_text: '',
    document_text: '',
    match_lv_1: '',
    match_lv_2: '',
    normal_txt: '',
    regex_pattern_lv_1: '',
    regex_pattern_lv_2: '',
    chunk_size: '',
    chunk_overlap: '',
    radio_select: 'chunk_length',
    fileName: ''
  },
  split_document: [],
  doc_properties: {},
  file_name: '',
  file_path: '',
  duplicate_file: false,
  save_chunk: {
    uid: '',
    status: '',
    chunk_total: 0
  },
  status_extract_file: {
    isFetched: false,
    isFetching: false,
  },
  status_preview_file: {
    isFetched: false,
    isFetching: false,
  },
  status_split_file: {
    isFetched: false,
    isFetching: false,
  },
  status_view_chunks: {
    isFetched: false,
    isFetching: false,
  }
}

const defaultStatus = {
  isFetched: false,
  isFetching: false,
}

const DocumentManagementSlice = createSlice({
  name: "user_management",
  initialState,
  reducers: {
    fetchDocumentTree(
      state: Draft<IDocumentManagementState>,
    ) {

    },
    fetchDocumentTreeSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<IDocumentManagementData[]>
    ) {
      state.data = action.payload
    },
    fetchDocumentTreeFailure(
      state: Draft<IDocumentManagementState>,
    ) {

    },
    fetchDocument(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data.status_view_chunks = {
        ...state.file_data.status_view_chunks,
        isFetching: true,
      }
    },
    fetchDocumentSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data = {
        ...state.file_data,
        split_document: action.payload.chunk_info.map((item: any, index: number) => {
          return {
            ...item,
            index: index + 1
          }
        }),
        doc_properties: action.payload.doc_properties,
        status_view_chunks: {
          isFetching: false,
          isFetched: true,
        }
      }
    },
    fetchDocumentFailure(
      state: Draft<IDocumentManagementState>,
    ) {

    },
    setFetchedViewChunk(
      state: Draft<IDocumentManagementState>,
    ) {
      state.file_data = {
        ...state.file_data,
        split_document: [],
        status_view_chunks: {
          isFetching: false,
          isFetched: false,
        }
      }
    },
    createNewFolder(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {

    },
    deleteFolder(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {

    },
    deleteFiles(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {

    },
    uploadFile(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data = {
        ...state.file_data,
        status_extract_file: {
          ...state.file_data.status_extract_file,
          isFetching: true,
        }
      }
    },
    uploadFileSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data = {
        ...state.file_data,
        document_extract: {
          original_text: action.payload.original_text,
          document_text: action.payload.document_text,
          match_lv_1: '',
          match_lv_2: '',
          normal_txt: '',
          regex_pattern_lv_1: '',
          regex_pattern_lv_2: '',
          chunk_size: '',
          chunk_overlap: '',
          radio_select: 'chunk_length',
          fileName: ''
        },
        file_name: action.payload.filename,
        file_path: '',
        status_extract_file: {
          isFetching: false,
          isFetched: true,
        }
      }
    },
    duplicateFile(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data = {
        ...state.file_data,
        status_extract_file: {
          isFetched: false,
          isFetching: false,
        },
        duplicate_file: action.payload.duplicate
      }
    },
    uploadFileFailure(
      state: Draft<IDocumentManagementState>
    ) {
      state.file_data = {
        ...defaultFileData
      }
    },
    setFetchedExtract(
      state: Draft<IDocumentManagementState>
    ) {
      state.file_data.status_extract_file = {
        ...defaultStatus
      }
    },
    submitDataEdit(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data.status_preview_file = {
        ...state.file_data.status_preview_file,
        isFetching: true,
      }
    },
    submitDataEditSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data = {
        ...state.file_data,
        document_extract: {
          ...state.file_data.document_extract,
          ...action.payload
        },
        status_preview_file: {
          isFetching: false,
          isFetched: true,
        }
      }
    },
    submitDataEditFailure(
      state: Draft<IDocumentManagementState>,
    ) {
      state.file_data = {
        ...defaultFileData
      }
    },
    setFetchedPreview(
      state: Draft<IDocumentManagementState>
    ) {
      state.file_data.status_preview_file = {
        ...defaultStatus,
      }
    },
    saveDocument(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data.status_split_file = {
        ...state.file_data.status_split_file,
        isFetching: true,
      }
    },
    saveDocumentSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data = {
        ...state.file_data,
        split_document: action.payload,
        status_split_file: {
          isFetching: false,
          isFetched: true,
        }
      }
    },
    saveDocumentFailure(
      state: Draft<IDocumentManagementState>,
    ) {
      state.file_data = {
        ...defaultFileData
      }
    },
    setFetchedDocument(
      state: Draft<IDocumentManagementState>,
    ) {
      state.file_data.status_view_chunks = {
        ...defaultStatus
      }
    },
    setFetchedSplit(
      state: Draft<IDocumentManagementState>,
    ) {
      state.file_data.status_split_file = {
        ...defaultStatus
      }
    },
    saveChunk(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data.status_split_file = {
        ...state.file_data.status_split_file,
        isFetching: true,
      }
    },
    saveChunkSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.file_data = {
        ...state.file_data,
        save_chunk: {
          uid: action.payload.status_task.uid,
          status: action.payload.status_task.status,
          chunk_total: action.payload.status_task.chunk_total
        }
      }
      state.data = action.payload.tree
    },
    saveChunkFailure(
      state: Draft<IDocumentManagementState>,
    ) {
      state.file_data = {
        ...defaultFileData
      }
    },
    updateChunk(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) { },
    updateChunkSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) { },
    updateChunkFailure(
      state: Draft<IDocumentManagementState>,
    ) { },
    downloadFilePDF(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<string>
    ) { },
    setStatusDuplicateFile(
      state: Draft<IDocumentManagementState>,
    ) {
      state.file_data = {
        ...state.file_data,
        duplicate_file: false,
      }
    },
    clearStateDocument(
      state: Draft<IDocumentManagementState>,
    ) {
      state.data = initialState.data;
      state.file_data = initialState.file_data;
    },
    clearExtractDocument(
      state: Draft<IDocumentManagementState>
    ) {
      state.file_data.document_extract = defaultFileData.document_extract;
    },
    clearSplitDocument(
      state: Draft<IDocumentManagementState>
    ) {
      state.file_data.split_document = []
    },
    clearFileDataState(
      state: Draft<IDocumentManagementState>
    ) {
      state.file_data = {
        ...defaultFileData
      }
    },
    clearTreeData(
      state: Draft<IDocumentManagementState>
    ) {
      state.data = []
    },
    fetchRegexPattern(
      state: Draft<IDocumentManagementState>,
    ) {
    },
    fetchRegexPatternSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.regex_pattern = action.payload;
    },
    addNewRegex(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {

    },
    addNewRegexSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.regex_pattern = action.payload;
    },
    addNewCrawlingURL(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {

    },
    addNewCrawlingURLSuccess(
      state: Draft<IDocumentManagementState>,
      action: PayloadAction<any>
    ) {
      state.data = action.payload;
    },
    cancelRequest() { },
    clearDataSaveChunk(state: Draft<IDocumentManagementState>) {
      state.file_data = {
        ...state.file_data,
        save_chunk: initialState.file_data.save_chunk
      }
    }
  },
});

// Actions
export const createNewFolder = DocumentManagementSlice.actions.createNewFolder;
export const deleteFolder =
  DocumentManagementSlice.actions.deleteFolder;
export const deleteFiles =
  DocumentManagementSlice.actions.deleteFiles;

export const cancelRequest = DocumentManagementSlice.actions.cancelRequest;

export const fetchRegexPattern = DocumentManagementSlice.actions.fetchRegexPattern;
export const fetchRegexPatternSuccess = DocumentManagementSlice.actions.fetchRegexPatternSuccess;

export const fetchDocumentTree = DocumentManagementSlice.actions.fetchDocumentTree;
export const fetchDocumentTreeSuccess = DocumentManagementSlice.actions.fetchDocumentTreeSuccess;
export const fetchDocumentTreeFailure = DocumentManagementSlice.actions.fetchDocumentTreeFailure;

export const fetchDocument = DocumentManagementSlice.actions.fetchDocument;
export const fetchDocumentSuccess = DocumentManagementSlice.actions.fetchDocumentSuccess;
export const fetchDocumentFailure = DocumentManagementSlice.actions.fetchDocumentFailure;

export const uploadFile = DocumentManagementSlice.actions.uploadFile;
export const uploadFileSuccess = DocumentManagementSlice.actions.uploadFileSuccess;
export const uploadFileFailure = DocumentManagementSlice.actions.uploadFileFailure;

export const duplicateFile = DocumentManagementSlice.actions.duplicateFile;

export const submitDataEdit = DocumentManagementSlice.actions.submitDataEdit;
export const submitDataEditSuccess = DocumentManagementSlice.actions.submitDataEditSuccess;
export const submitDataEditFailure = DocumentManagementSlice.actions.submitDataEditFailure;

export const saveDocument = DocumentManagementSlice.actions.saveDocument;
export const saveDocumentSuccess = DocumentManagementSlice.actions.saveDocumentSuccess;
export const saveDocumentFailure = DocumentManagementSlice.actions.saveDocumentFailure;

export const saveChunk = DocumentManagementSlice.actions.saveChunk;
export const saveChunkSuccess = DocumentManagementSlice.actions.saveChunkSuccess;
export const saveChunkFailure = DocumentManagementSlice.actions.saveChunkFailure;

export const updateChunk = DocumentManagementSlice.actions.updateChunk;
export const updateChunkSuccess = DocumentManagementSlice.actions.updateChunkSuccess;
export const updateChunkFailure = DocumentManagementSlice.actions.updateChunkFailure;

export const addNewRegex = DocumentManagementSlice.actions.addNewRegex;
export const addNewRegexSuccess = DocumentManagementSlice.actions.addNewRegexSuccess;

export const addNewCrawlingURL = DocumentManagementSlice.actions.addNewCrawlingURL;
export const addNewCrawlingURLSuccess = DocumentManagementSlice.actions.addNewCrawlingURLSuccess;

export const downloadFilePDF = DocumentManagementSlice.actions.downloadFilePDF;

export const setFetchedExtract = DocumentManagementSlice.actions.setFetchedExtract;
export const setFetchedPreview = DocumentManagementSlice.actions.setFetchedPreview;
export const setFetchedSplit = DocumentManagementSlice.actions.setFetchedSplit;
export const setFetchedViewChunk = DocumentManagementSlice.actions.setFetchedViewChunk;
export const setStatusDuplicateFile = DocumentManagementSlice.actions.setStatusDuplicateFile;

export const clearExtractDocument = DocumentManagementSlice.actions.clearExtractDocument;
export const clearSplitDocument = DocumentManagementSlice.actions.clearSplitDocument;
export const clearStateDocument = DocumentManagementSlice.actions.clearStateDocument;
export const clearFileDataState = DocumentManagementSlice.actions.clearFileDataState;
export const clearTreeData = DocumentManagementSlice.actions.clearTreeData;
export const clearDataSaveChunk = DocumentManagementSlice.actions.clearDataSaveChunk;

// Selectors
export const getDataDocuments = (state: RootState) =>
  state.document_management.data;
export const getDataDocumentExtract = (state: RootState) =>
  state.document_management.file_data.document_extract;
export const getDataDocumentSplit = (state: RootState) =>
  state.document_management.file_data.split_document;
export const getDataDocProperties = (state: RootState) =>
  state.document_management.file_data.doc_properties;
export const getFetchingExtract = (state: RootState) =>
  state.document_management.file_data.status_extract_file.isFetching;
export const getFetchedExtract = (state: RootState) =>
  state.document_management.file_data.status_extract_file.isFetched;
export const getFetchingPreview = (state: RootState) =>
  state.document_management.file_data.status_preview_file.isFetching;
export const getFetchedPreview = (state: RootState) =>
  state.document_management.file_data.status_preview_file.isFetched;
export const getFetchingSplit = (state: RootState) =>
  state.document_management.file_data.status_split_file.isFetching;
export const getFetchedSplit = (state: RootState) =>
  state.document_management.file_data.status_split_file.isFetched;
export const getFetchingViewChunk = (state: RootState) =>
  state.document_management.file_data.status_view_chunks.isFetching;
export const getFetchedViewChunk = (state: RootState) =>
  state.document_management.file_data.status_view_chunks.isFetched;
export const getStatusDuplicateFile = (state: RootState) =>
  state.document_management.file_data.duplicate_file;
export const getDataSaveChunk = (state: RootState) =>
  state.document_management.file_data.save_chunk;
export const getRegexPattern = (state: RootState) =>
  state.document_management.regex_pattern;
export const getFileNameDocumentExtract = (state: RootState) =>
  state.document_management.file_data.file_name;
export const getChuckSize = (state: RootState) => 
  state.document_management.file_data.document_extract.chunk_size;
export const getChuckOverlap = (state: RootState) => 
  state.document_management.file_data.document_extract.chunk_overlap;
// Reducer
const DocumentManagementReducer = DocumentManagementSlice.reducer;
export default DocumentManagementReducer;
